import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export async function deleteAdminProduct(
	productId: string,
): Promise<
	| {
			status: "success";
			message: string;
	  }
	| { status: "error"; message: string }
> {
	try {
		const response = await api.delete(`/product/delete`, {
			data: {
				product_id: productId,
			},
		});

		return {
			status: "success",
			message: response.data.message,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{ message: string }>;

		return {
			status: "error",
			message:
				axiosError.response?.data?.message ||
				"Erro ao remover produto. Tente novamente mais tarde.",
		};
	}
}
